<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Store" formControlName="store">
    <form-group-select entity="store"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="Store"></form-group-select>
  </form-group-context>


  <form-group-context label="Product" formControlName="product">
    <form-group-select entity="product"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="{parentStore: data?.store?.id || data?.store}"
                       bindValue="id"
                       placeholder="Product"></form-group-select>
  </form-group-context>

  <form-group-context label="Active" formControlName="active">
    <form-group-simple type="checkbox" name="active"></form-group-simple>
  </form-group-context>

  <form-group-context label="Free" formControlName="free">
    <form-group-simple type="checkbox" name="free"></form-group-simple>
  </form-group-context>

  <form-group-context label="Available for downloading" formControlName="availableForDownloading">
    <form-group-simple type="checkbox" name="availableForDownloading"></form-group-simple>
  </form-group-context>

  <form-group-context label="Legacy" formControlName="legacy">
    <form-group-simple type="checkbox" name="legacy"></form-group-simple>
  </form-group-context>

<!--  <form-group-context label="Legacy ID"-->
<!--                      *ngIf="form.get('legacyId')"-->
<!--                      formControlName="legacyId">-->
<!--    <form-group-simple name="legacyId" placeholder="id"></form-group-simple>-->
<!--  </form-group-context>-->

  <form-group-context label="Files"
                      *ngIf="form.get('assets')"
                      formControlName="assets">
    <form-group-files name="assets" [accepted]="acceptedFiles" [config]="projectLegacyDropzoneConfig"></form-group-files>
  </form-group-context>

  <form-group-context label="Covers"
                      *ngIf="form.get('covers')"
                      formControlName="covers">
    <form-group-files name="covers" [accepted]="acceptedCovers" [config]="projectLegacyDropzoneConfig"></form-group-files>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
